import { NgFor } from '@angular/common'
import { Component, ElementRef, forwardRef, Input, ViewChild } from '@angular/core'
import {
    FormBuilder,
    FormGroup,
    NG_VALUE_ACCESSOR,
    ReactiveFormsModule,
} from '@angular/forms'

@Component({
    selector: 'app-editor',
    standalone: true,
    imports: [NgFor, ReactiveFormsModule],
    templateUrl: './editor.component.html',
    styleUrl: './editor.component.css',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => EditorComponent),
            multi: true,
        },
    ],
})
export class EditorComponent {
    @ViewChild('tagInput') tagInputRef!: ElementRef<HTMLInputElement>

    @Input() tags: string[] = []
    form!: FormGroup
    private onChange = (_: any) => {}
    private onTouched = () => {}

    constructor(private fb: FormBuilder) {}

    ngOnInit(): void {
        this.form = this.fb.group({
            tag: [''],
        })
    }

    writeValue(value: string[] | null): void {
        if (value) {
            this.tags = value
        }
    }

    registerOnChange(fn: any): void {
        this.onChange = fn
    }

    registerOnTouched(fn: any): void {
        this.onTouched = fn
    }

    focusTagInput(): void {
        this.tagInputRef.nativeElement.focus()
        this.onTouched()
    }

    onKeyUp(event: KeyboardEvent): void {
        const inputValue = this.form.get('tag')?.value?.trim()

        if (event.key === 'Backspace' && !inputValue) {
            this.removeTag()
            return
        }

        if (event.key === ',' || event.key === ' ') {
            this.addTag(inputValue)
            this.form.get('tag')?.setValue('')
            event.preventDefault()
        }
    }

    addTag(tag: string): void {
        if (!tag) return

        tag = tag.replace(/[,\s]+$/, '')

        if (tag.length > 0 && !this.tags.includes(tag)) {
            this.tags.push(tag)

            this.onChange(this.tags)
        }
    }

    removeTag(tag?: string): void {
        if (tag) {
            this.tags = this.tags.filter((t) => t !== tag)
        } else {
            this.tags.pop()
        }

        this.onChange(this.tags)
    }
}
